import cn from 'classnames'
import { Button, BUTTON_TYPES } from 'components/Button'
import { ReactComponent as Attachment16 } from 'assets/svg/Attachment16.svg'
import { ReactComponent as Delete16 } from 'assets/svg/Delete16.svg'
import { TAttachmentProps } from './types'
import './styles.scss'
import { useMemo } from 'react'
import { Typography } from 'components/Typography'
import { defaultDateFormat } from 'helper/dates'
import { LABELS } from '../../constants'
import { Tooltip } from '../Tooltip/Tooltip'

export const Row = ({
  filename,
  onDelete,
  className,
  disableActions,
  link,
  createdAt,
  showDetails,
  icon
}: TAttachmentProps) => {
  const CreatedAt = useMemo(
    () =>
      createdAt && (
        <div className="column gap-4">
          <Typography.Label>{LABELS.UPLOAD_DATE}</Typography.Label>
          <div className="attachment__created_at">
            <Typography.Body1>{defaultDateFormat(createdAt)}</Typography.Body1>
          </div>
        </div>
      ),
    [createdAt]
  )

  return (
    <div className={cn('attachment row', className)}>
      <div className="attachment__content row gap-24">
        {showDetails && CreatedAt}
        <Tooltip title={filename}>
          <Button
            type={BUTTON_TYPES.LINK}
            icon={icon ?? <Attachment16 className="attachment__icon" />}
            onClick={() => window.open(link)}
          >
            {filename}
          </Button>
        </Tooltip>
      </div>
      {onDelete && !disableActions && (
        <div className="attachment__actions">
          <Button.Icon
            type={BUTTON_TYPES.LINK}
            icon={<Delete16 />}
            onClick={onDelete}
            small
          />
        </div>
      )}
    </div>
  )
}
